import React from "react";
import { ArrowRight } from "lucide-react";

export function Rationale({ data, language }) {
  const L = language === "fr"
    ? { empty: "L'analyse apparaîtra ici après l'optimisation.", before: "Avant", after: "Après", why: "Pourquoi", examples: "Exemples de reformulations", summary: "Synthèse" }
    : { empty: "The analysis will appear here after optimization.", before: "Before", after: "After", why: "Why", examples: "Rewrite examples", summary: "Takeaway" };

  if (!data) {
    return <p className="text-sm text-[var(--ink-dim)] italic">{L.empty}</p>;
  }

  const changes = Array.isArray(data.changes) ? data.changes : [];

  return (
    <div className="space-y-6 fade-in" data-testid="rationale">
      {data.intro && (
        <p className="text-[15px] leading-relaxed text-[var(--ink)]">
          {data.intro}
        </p>
      )}

      {changes.length > 0 && (
        <div>
          <div className="label-eyebrow mb-3">{L.examples} · {changes.length}</div>
          <div className="space-y-3">
            {changes.map((c, i) => (
              <div key={i} className="rounded-lg border border-[var(--border)] bg-[var(--bg-2)] p-4" data-testid={`rationale-change-${i}`}>
                <div className="flex items-start gap-3 text-[13px] leading-relaxed">
                  <span className="diff-before flex-1">{c.before}</span>
                  <ArrowRight size={14} className="shrink-0 mt-1 text-[var(--ink-dim)]" />
                  <span className="diff-after flex-1">{c.after}</span>
                </div>
                {c.why && (
                  <div className="mt-2 text-[12px] text-[var(--ink-dim)] border-t border-[var(--border)] pt-2">
                    <span className="label-eyebrow mr-2">{L.why}</span>
                    {c.why}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {data.conclusion && (
        <div className="rounded-lg border border-[var(--border-bright)] bg-[var(--surface-2)] p-4">
          <div className="label-eyebrow mb-2">{L.summary}</div>
          <p className="text-[14px] leading-relaxed text-[var(--ink)]">{data.conclusion}</p>
        </div>
      )}
    </div>
  );
}
